import React from 'react';
import { Button, Heading, Image, Link, Text, VStack } from '@chakra-ui/react';
import { Card } from '@/imports/ui/chakra/components/Card';

const appLinks = [
  {
    label: 'Download on Google Play',
    href: 'https://play.google.com/store/apps/details?id=com.app.tradewing&pcampaignid=web_share',
    iconSrc: '/images/google-play.png',
    iconAlt: 'Google Play',
  },
  {
    label: 'Download on the App Store',
    href: 'https://apps.apple.com/ph/app/tradewingllc/id6742144752',
    iconSrc: '/images/apple.png',
    iconAlt: 'App Store',
  },
];

const DownloadApp: React.FC = () => (
  <Card px={4} py={6} w="full" textAlign="center">
    <Heading size="md" mb={1}>
      Download the Tradewing Mobile App
    </Heading>

    <Text color="gray.500" mb={4}>
      Stay connected with your community anytime, anywhere.
    </Text>

    <VStack spacing={2} mb={2} justify="center">
      {appLinks.map(({ label, href, iconSrc, iconAlt }) => (
        <Link
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          w="full"
        >
          <Button
            w="full"
            leftIcon={<Image src={iconSrc} alt={iconAlt} boxSize="18px" />}
            whiteSpace={'wrap'}
            colorScheme="blue"
            fontWeight="600"
            fontSize={{ base: 'base', xl: '13.5px', lg: '12px', md: 'sm' }}>
            {label}
          </Button>
        </Link>
      ))}
    </VStack>

    <Link
      href="https://support.tradewing.com/knowledge-base/navigating-the-tradewing-llc-mobile-app"
      target="_blank"
      rel="noopener noreferrer"
      fontSize="sm"
      fontWeight="semibold"
      textDecoration="underline"
      _hover={{ color: 'blue.600' }}
    >
      Learn how to use the mobile app
    </Link>
  </Card>
);

export default DownloadApp;
